import mutationsTypes from '@/store/mutationTypes'
import axios from 'axios'
import api from '@/config/api'
import apiMock from '@/config/apiMock'
import { commonUtil } from '@/util'
import getCsrfToken from '@/store/Csrf'
import { fileUploadApiResult } from '@/config'

const Actions = {
  // CO01 ファイルアップロード
  fileUpload: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    file
  ) => {
    const instance = axios.create({
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    await getCsrfToken()
    return await instance
      // .get(apiMock.FILE_UPLOAD)
      .post(api.FILE_UPLOAD, file)
      .then((response) => {
        const path = mutationsTypes.FILE_SET_UPLOAD_URL
        commit(path, response.data.data)
        const getData = getters.getUploadUrlFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        console.log(error.response)
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // ES01 外部CSV取込_CSVアップロード
  externalSystemCsvUpload: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    const instance = axios.create({
      headers: { 'Content-Type': 'multipart/form-data' }
    })
    await getCsrfToken()
    return await instance
      // .get(apiMock.ETERNAL_SYSTEM_CSV_UPLOAD)
      .post(api.ETERNAL_SYSTEM_CSV_UPLOAD, params)
      .then((response) => {
        const path = mutationsTypes.FILE_SET_CSV_UPLOAD_TOTAL
        commit(path, response.data.data)

        return fileUploadApiResult.API_RESULT_STATUS.SUCCESS
      })
      .catch((error) => {
        if (error.response.data.data && error.response.data.data.errorList) {
          // ファイル内のバリデーションエラー時、画面にエラー発生した行数を表示するのでstoreに格納
          const path = mutationsTypes.FILE_SET_CSV_UPLOAD_TOTAL
          commit(path, error.response.data.data)
          commit(
            mutationsTypes.FILE_SET_CSV_UPLOAD_ERROR_LIST,
            error.response.data.data
          )
          return fileUploadApiResult.API_RESULT_STATUS.FAIL_WITH_ERRORLIST
        } else {
          commonUtil.afterApiFailProcess(error.response)
        }

        return fileUploadApiResult.API_RESULT_STATUS.FAIL
      })
  },
  // ES02 外部CSV取込_CSV内容一覧の検索
  externalSystemCsvUploaded: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      // .get(apiMock.ETERNAL_SYSTEM_CSV_UPLOADED)
      .get(api.ETERNAL_SYSTEM_CSV_UPLOADED, { params: params })
      .then((response) => {
        const path = mutationsTypes.FILE_SET_CSV_UPLOAD_HISTORY_LIST
        commit(path, response.data)

        const getData = getters.getCsvUploadHistoryListFromState
        const ret = commonUtil.afterApiSuccessProcess(response, getData)
        return ret
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // ES03 外部CSV取込_CSV内容の無効化
  externalSystemCsvInvalidate: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      .post(`${api.ETERNAL_SYSTEM_CSV_UPLOADED}/${params.id}/cancel`)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // ES04 外部CSV取込_CSV内容の販売登録
  externalSystemCsvSave: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      .post(api.ETERNAL_SYSTEM_CSV_SALE, params)
      .then((response) => {
        return true
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        commonUtil.afterApiFailProcess(error.response)
        return false
      })
  },
  // ES05 外部CSV取込_CSV内容の依存送信
  externalSystemExcelDownload: async (
    { state, dispatch, commit, getters, rootGetters, rootState },
    params
  ) => {
    return await axios
      .post(api.ETERNAL_SYSTEM_SEND, params, { responseType: 'blob' })
      .then((response) => {
        return window.URL.createObjectURL(new Blob([response.data]))
      })
      .catch((error) => {
        // commonErrorControl(error.response)
        // レスポンスにBlobを指定するとエラーが取れなくなってしまうので、再度リクエストしエラーを取得する
        axios
          .post(api.ETERNAL_SYSTEM_SEND, params)
          .then((res) => {
            alert('ダウンロード失敗')
          })
          .catch((err) => {
            commonUtil.afterApiFailProcess(err.response)
          })

        return false
      })
  }
}

export default Actions
